/**
 * Transforms a single exam level item to the GraphQL node format
 */
export function mapExamLevelToNode(item) {
    return {
        id: item.id,
        data: item.data,
        type: item.type,
        ctime: item.ctime,
        utime: item.utime,
        sequence: item.sequence ?? 0,
    };
}
/**
 * Transforms a paginated list of exam levels to the GraphQL format
 */
export function mapPaginatedExamLevels(result) {
    return {
        totalCount: result?.totalCount ?? 0,
        list: result?.list.map(mapExamLevelToNode) ?? [],
    };
}
